import applogger from '@applogger'
let pageMixin
let asyncLoader

// eslint-disable-next-line no-undef
if (APPSETTINGS.DataStore.store === 'ichabodcms') {
  asyncLoader = function({ store, route }, edit = false) {
    applogger.debug('special-pages asyncData starting')
    let obj = {path: route.fullPath}
    if (edit) {
      obj = {id: route.params.itemid}
    }
    return store.dispatch('item/load', obj)
      .then(node => {
        let loaders = []
        loaders.push(store.dispatch('blob/load', {blobID: `page-blob-top--node-${node.nid}`}))
        loaders.push(store.dispatch('blob/load', {blobID: `page-blob-bottom--node-${node.nid}`}))
        return Promise.all([node, Promise.all(loaders)])
      })
      .then(([node, loaders]) => {
        applogger.debug('special-pages asyncData Complete')
        return {
          itemid: node.nid,
          title: node.title
        }
      })
  }

  pageMixin = {
    computed: {
      itemid() {
        return this.item.id
      },
      item() {
        let item
        if (this.$route.path) {
          item = this.$store.getters['item/getByPath'](this.$route.path)
        }
        else {
          item = this.$store.getters['item/getByid'](this.$route.params.itemid)
        }
        return (item) || {name: '', id: '', body: ''}
      },
      notpublished: function() {
        return !this.item.published
      },
      hasBody: function() {
        return (this.item.body && this.item.body.length > 0)
      }
    }
  }
}
else {
  asyncLoader = function({ store, route, router }) {
    applogger.log(`special-pages asyncData starting: ${route.path}`)
    return store.dispatch('node/lookupItem', {path: route.path})
      .then(iteminfo => store.dispatch('node/load', { nid: iteminfo.id }))
      .then(node => {
        let loaders = [
          Promise.resolve(node)
        ]
        let blobsToLoad = [
          `page-blob-top--node-${node.nid}`,
          `page-blob-bottom--node-${node.nid}`
        ]
        if (node.type === 'sp_constructed') {
          const pageData = JSON.parse(node.construct_data)
          const slices = pageData.slices.filter(slice => slice.type === 'content-creator')
          if (slices.length && slices.length > 0) {
            slices.forEach(slice => blobsToLoad.push(`constructed-page--${node.nid}-cc--${slice.data.ccid}`))
          }
        }
        loaders.push(store.dispatch('blob/loadgroup', { blobIDs: blobsToLoad, filestore: 'website', cacheOptions: { scope: 'global', ttl: 3600 * 12 } }))
        return Promise.all(loaders)
      })
      .then(([node, loaders]) => {
        applogger.log('special-pages asyncData complete')
        return {
          itemid: node.nid,
          title: node.title
        }
      })
      .catch(err => {
        applogger.error('An error occurred loading the page.')
        switch (err.response.status) {
        case 403:
          store.commit('SET_PAGE_SETTING', { key: 'error', value: 403 })
          break
        case 404:
          store.commit('SET_PAGE_SETTING', { key: 'error', value: 404 })
          break
        default:
          store.commit('SET_PAGE_SETTING', { key: 'error', value: 500 })
          break
        }
      })
  }

  pageMixin = {
    data: function() {
      return {
        item: null
      }
    },
    created: function() {
      this.item = this.$store.getters['node/getByPath'](this.$route.path)
    },
    computed: {
      itemid() {
        return this.item ? this.item.nid : ''
      },
      notpublished: function() {
        return (parseInt(this.item.status) !== 1)
      },
      hasBody: function() {
        return (this.item.body && this.item.body.length > 0)
      },
      // item() {
      //   return this.$store.getters['node/getByPath'](this.$route.path)
      // },
      title() {
        return this.item.title
      }
    }
  }
}

function getPreloadImageUrlPromises(store, presetSets, imageSets) {
  try {
    let files = []
    let i = 0
    while (i < presetSets.length && i < imageSets.length) {
      const preset = presetSets[i] || '__original'
      const images = imageSets[i].filter(img => img && img.filepath) || []
      files = files.concat(
        images.map(img => ({ ...img, preset: preset }))
      )
      files = files.concat(
        images.map(img => ({ ...img, preset: preset + '__lowres' }))
      )
      i++
    }
    return store.dispatch('filestore/getFileURLBulk', { files, filestorename: 'website' })
  }
  catch {
    return []
  }
}

export default pageMixin
export {
  pageMixin,
  asyncLoader,
  getPreloadImageUrlPromises
}
